"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const galleryItems = [{
  index: "01",
  caseNo: "ST_LOOK_01",
  year: "2024",
  jurisdiction: "RUNWAY",
  title: "Obsidian Drape Silhouette",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/runway_obsidian_drape.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/runway_obsidian_drape.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/runway_obsidian_drape.png-wvc-sizes",
  alt: "Studio Thorne runway look featuring obsidian drape silhouette",
  colSpan: "lg:col-start-1 lg:col-span-5",
  aspect: "aspect-[3/4]",
  offset: "lg:mt-0"
}, {
  index: "02",
  caseNo: "ST_TECH_02",
  year: "2024",
  jurisdiction: "ATELIER",
  title: "Technical Pattern Blueprint",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/atelier_pattern_blueprint.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/atelier_pattern_blueprint.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/atelier_pattern_blueprint.png-wvc-sizes",
  alt: "Technical pattern making blueprint for Studio Thorne",
  colSpan: "lg:col-start-7 lg:col-span-6",
  aspect: "aspect-[4/3]",
  offset: "lg:mt-20"
}, {
  index: "03",
  caseNo: "ST_FAB_03",
  year: "2024",
  jurisdiction: "TEXTILE",
  title: "Sustainable Hemp Weave",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/textile_hemp_weave.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/textile_hemp_weave.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/textile_hemp_weave.webp-wvc-sizes",
  alt: "Close up of sustainable hemp weave textile",
  colSpan: "lg:col-start-2 lg:col-span-5",
  aspect: "aspect-[4/3]",
  offset: "lg:mt-30"
}, {
  index: "04",
  caseNo: "ST_LOOK_04",
  year: "2024",
  jurisdiction: "RUNWAY",
  title: "Urban Utility Shell",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/runway_utility_shell.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/runway_utility_shell.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/runway_utility_shell.png-wvc-sizes",
  alt: "Studio Thorne urban utility shell runway look",
  colSpan: "lg:col-start-8 lg:col-span-5",
  aspect: "aspect-[3/4]",
  offset: "lg:mt-12"
}, {
  index: "05",
  caseNo: "ST_TECH_05",
  year: "2024",
  jurisdiction: "ATELIER",
  title: "Garment Construction Detail",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/atelier_construction_detail.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/atelier_construction_detail.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/atelier_construction_detail.webp-wvc-sizes",
  alt: "Close up of garment construction stitching detail",
  colSpan: "lg:col-start-1 lg:col-span-6",
  aspect: "aspect-[4/3]",
  offset: "lg:mt-28"
}, {
  index: "06",
  caseNo: "ST_FAB_06",
  year: "2024",
  jurisdiction: "TEXTILE",
  title: "Raw Silk Draping",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/textile_silk_draping.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/textile_silk_draping.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/textile_silk_draping.webp-wvc-sizes",
  alt: "Raw silk fabric draping process",
  colSpan: "lg:col-start-8 lg:col-span-4",
  aspect: "aspect-[3/4]",
  offset: "lg:mt-16"
}];
export default function () {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: footerRef,
    isVisible: footerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="5322" id="the-lookbook-gallery" className="bg-background text-foreground relative py-24 md:py-32 px-6 md:px-10 lg:px-16 overflow-hidden">
      <div className="max-w-[1440px] mx-auto">
        {}
        <div ref={headerRef} className={`grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 mb-20 md:mb-28 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {}
          <div className="lg:col-span-4 flex items-start">
            <div className="flex items-center gap-3">
              <span className="block h-px w-8 bg-primary" aria-hidden="true" />
              <span className="font-mono text-xs uppercase tracking-[0.2em] text-primary">The Lookbook Gallery</span>
            </div>
          </div>

          {}
          <div className="lg:col-span-8 lg:pl-8 lg:border-l lg:border-border/40">
            <h2 className="font-default text-foreground text-4xl md:text-5xl lg:text-[56px] leading-[1.05] tracking-tight">
              Design, <em className="font-default italic text-primary">refined</em>.
            </h2>
            <p className="mt-6 font-default text-base md:text-lg text-muted-foreground max-w-xl leading-relaxed">
              A curated archive of Studio Thorne’s seasonal evolution, from technical sketches to final runway execution.
            </p>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-y-12 lg:gap-y-0 lg:gap-x-6">
          {galleryItems.map((item, i) => <article key={item.index} data-index={i} className={`group relative ${item.colSpan} ${item.offset}`}>
              {}
              <div className="absolute -top-3 -left-3 z-20 flex items-center justify-center w-9 h-9 rounded-lg bg-background border border-primary/60">
                <span className="font-mono text-[10px] tracking-widest text-primary">
                  {item.index}
                </span>
              </div>

              {}
              <div className={`relative ${item.aspect} overflow-hidden border border-border/60 bg-card`}>
                <img src={item.image} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={item.alt} loading="lazy" decoding="async" className="w-full h-full object-cover grayscale transition-transform duration-[600ms] ease-out group-hover:scale-[1.03]" />

                {}
                <div className="absolute inset-0 bg-primary opacity-0 group-hover:opacity-20 transition-opacity duration-500 ease-out pointer-events-none" aria-hidden="true" />

                {}
                <div className="absolute inset-x-0 bottom-0 translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out bg-background/95 backdrop-blur-sm border-t border-primary/40 p-5 md:p-6">
                  <div className="flex flex-wrap items-center gap-x-4 gap-y-1 mb-3">
                    <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-primary">
                      {item.caseNo}
                    </span>
                    <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-muted-foreground">
                      {item.year}
                    </span>
                    <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-muted-foreground">
                      {item.jurisdiction}
                    </span>
                  </div>
                  <h3 className="font-default text-foreground text-lg md:text-xl leading-snug">
                    {item.title}
                  </h3>
                </div>
              </div>

              {}
              <div className="mt-4 flex items-start justify-between gap-4">
                <h3 className="font-default text-foreground text-base md:text-lg leading-snug max-w-[80%]">
                  {item.title}
                </h3>
                <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-muted-foreground whitespace-nowrap pt-1">
                  {item.year}
                </span>
              </div>
            </article>)}
        </div>

        {}
        <div ref={footerRef} className={`mt-24 md:mt-32 flex justify-center transition-all duration-1000 ease-out ${footerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <Link to="/CollectionsPage" className="group relative inline-flex items-center gap-3 font-mono text-xs uppercase tracking-[0.25em] text-foreground hover:text-primary transition-colors duration-300">
            <span className="relative pb-2">
              View Full Collection
              <span className="absolute left-0 -bottom-0 h-px w-0 bg-primary transition-all duration-500 ease-out group-hover:w-full" aria-hidden="true" />
            </span>
            <ArrowRight className="size-4 text-primary transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>
      </div>
    </section>;
}